import React, { Suspense, lazy } from "react";
import { Helmet } from 'react-helmet-async';

const DestinationCTR = lazy(() => import("../containers/destination/DestinationCTR"));

function Tour() {
  return (
    <div>
      <Helmet>
        <title>Dubai Tours & Packages | Desert Safari, City Tours & More</title>
        <meta
          name="description"
          content="Book the best Dubai tours with Bonvoy Tourism. Enjoy desert safari, city sightseeing, adventure tours, dhow cruises, and exclusive travel experiences at the best prices."
        />
        <link rel="canonical" href="https://bonvoytourism.com/tour" />
      </Helmet>

      <Suspense
        fallback={
          <div className="flex items-center justify-center h-screen bg-white">
            <div className="w-16 h-16 border-4 border-t-[#ff9219] border-gray-200 rounded-full animate-spin"></div>
          </div>
        }
      >
        <DestinationCTR />
      </Suspense>
    </div>
  );
}

export default Tour;
